import React, { Fragment, useState } from 'react';
import { number, func } from 'prop-types';
import { connect } from 'react-redux';

import SummaryBox from './SummaryBox';
import {
  submitSurveyForApproval,
  resetState,
  getIEInitialData,
} from '../../../actions/turnkeyOmnibusActions';
import ConfirmationDialog from './ConfirmationDialog';

const SurveySummary = ({
  handleBack,
  resetState,
  getIEInitialData,
  activeAccountId,
  surveyId,
}) => {
  const [open, setOpen] = useState(false);
  const handleSubmit = () => {
    submitSurveyForApproval({ surveyId }).then(res => {
      if (res) {
        setOpen(true);
      }
    });
  };

  const _closeConfirmationModal = () => {
    setOpen(false);
    resetState();
    getIEInitialData(activeAccountId);
  };

  return (
    <Fragment>
      <div className="ie--steps--body ie--summary">
        <h2 className="ie--summary--title">Survey Summary</h2>
        <SummaryBox />
      </div>
      <footer className="ie--steps--footer">
        <button
          type="button"
          className="ie--button ie--button-sm"
          onClick={handleBack}
        >
          Back
        </button>
        <button
          type="button"
          className="ie--button ie--button-sm ie--button--active"
          onClick={handleSubmit}
        >
          Agree &amp; Submit For Approval
        </button>
      </footer>
      <ConfirmationDialog isOpen={open} onClose={_closeConfirmationModal} />
    </Fragment>
  );
};

SurveySummary.propTypes = {
  resetState: func.isRequired,
  handleBack: func.isRequired,
  getIEInitialData: func,
  activeAccountId: number.isRequired,
  surveyId: number.isRequired,
};

const mapStateToProps = ({ turnkeyOmnibus, account }) => {
  const {
    surveyInfo,
  } = turnkeyOmnibus;
  return {
    activeAccountId: account.activeAccountId,
    surveyId: surveyInfo.surveyId,
  };
};

export default connect(
  mapStateToProps,
  {
    resetState,
    getIEInitialData,
  }
)(SurveySummary);
